var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.svg)?_c('img',{class:_vm.$style.noSelect,attrs:{"src":_vm.svg}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }